export default {
  personal: {
    h1: `WHO ARE YOU?`,
    note: `Enter your contact info here. We ask your crush to give the phone number and/or email of the person they hope their secret admirer is.  If it’s the same as one you provide below, hooray!  The more alternatives you include, the greater your chances of making a match.  Most people enter at least one email and phone number.  And don’t worry, all info is solely used for match analysis and deleted either immediately after a match or after 30 days should no match occur.`,
    placeholder: "",
    actions: {
      next: `Next step`,
      prev: `Go back`
    }
  },
  target: {
    h1: `WHO’S THAT SPECIAL SOMEONE?`,
    note: `Tell us who is making your pulse race. We’ll send them a message saying someone’s fallen hard for them!`,
    placeholder: "",
    actions: {
      next: `Next step`,
      prev: `Go back`
    }
  },
  response: {
    h1: `Tell us who YOU have a crush on.`,
    note: `Enter all the email addresses and phone numbers you know to be associated with this person. The more alternatives you provide, the greater your chances of making a match!`,
    placeholder: "",
    actions: {
      next: `Next step`,
      prev: `Go back`
    }
  },
  message: {
    h1: `Drop a hint`,
    h3: `We’re going to send {{firstName}} the below message notifying them that they get someone’s heart fluttering. We strongly encourage you to give a little hint to increase your chances of making a mutual match. Some examples might be how you know each other, what common interests you have, or a description of yourself.`,
    placeholder: "Type your message here",
    h3response: `In case {{firstName}} on is NOT the person who first contacted us, we’ll send to send {{firstName}} the below message notifying them that they get someone’s heart fluttering. We strongly encourage you to give a little hint to increase your chances of making a mutual match. Some examples might be how you know each other, what common interests you have, or a description of yourself.`,
    message: `Hi {{firstName}},<br/><br/>
            We’re CrushPledge.com and we’re a new start-up site that allows people to “confess” their love to a friend, co-worker, classmate, or other acquaintance anonymously, so that there’s no embarrassment or awkwardness.
            Congrats to you because someone really likes you! They gave this hint about who they are: <span class="message">{{message}}</span>. They even pledged $10 to <span class="charityname">{{charity}}</span>, just to send this email to you. This means they’re serious about their feelings and are genuinely interested in making a deeper connection with you. `,
    noMessage: `sorry, the sender didn't provide a hint`,
    actions: {
      next: `Next step`,
      prev: `Go back`
    }
  },
  payment: {
    h1: `ALTHOUGH YOU CAN’T PUT A PRICE ON LOVE…`,
    h3: `We’re asking you to pledge $10 to a charity of your choice as a gesture of goodwill towards the seriousness of your feelings. Please enter your payment details below. (We know we’ve said it ad nauseum, but again, you’ll only be charged if a match is made.)`,
    note: `Until a match is made (or not made), your personal information is stored by our partner PandaPay, one of the leaders in processing of charitable giving transactions. They work with various charities including The Humane Society, Special Olympics, and the Ronald McDonald House and are experts in online payment security and privacy.`,
    actions: {
      next: `Review information`,
      prev: ``
    }
  },
  review: {
    h1: `TAKE ONE LAST LOOK…`,
    h3: `Please verify your information is correct, then accept the Terms and Conditions to start turning your dream scenario into reality.`,
    proceed: `Notify {{firstName}}`,
    titles: {
      charity: `Selected charity`,
      personal: `Your details`,
      target: `Recipient details`,
      payment: `Payment details`,
      message: `Message`
    },
    loading: `We are processing your request. Do not go back or refresh the page.`
  }
};



// WEBPACK FOOTER //
// ./assets/strings/details.js